module.exports = __webpack_public_path__ + "img/2023-1.184e66be.jpg";